import type { TFunction } from 'i18next';
import { FAQMessages, FAQText } from './FAQ.messages';

export interface FaqEntry {
  question: string;
  answer: string;
}

/**
 * The homepage FAQ, as both the visible accordion and the FAQPage structured data
 * read it.
 *
 * These used to be two separate lists. FAQ.tsx rendered six translated questions
 * while NewHomePage.tsx passed four hardcoded English ones to faqSchema, and the
 * four were paraphrases rather than the strings on the page — different wording,
 * two questions missing, and the same English emitted on all eight locales.
 *
 * Google requires FAQPage markup to match content that is visibly present on the
 * page, so that mismatch put the one rich result this site is well placed to earn
 * at risk on the page most likely to earn it. Deriving both from here means the
 * markup cannot drift from the page again, and each locale now describes itself.
 *
 * Order is the reading order: the objection every developer raises first — why not
 * just use an LLM directly — comes first, and FAQ.tsx opens it by default.
 */
export function faqEntries(t: TFunction): FaqEntry[] {
  return [
    {
      question: t(FAQMessages.Q_WHY_NOT_LLM, { defaultValue: FAQText.Q_WHY_NOT_LLM }),
      answer: t(FAQMessages.A_WHY_NOT_LLM, { defaultValue: FAQText.A_WHY_NOT_LLM }),
    },
    { question: t(FAQMessages.Q1), answer: t(FAQMessages.A1) },
    { question: t(FAQMessages.Q2), answer: t(FAQMessages.A2) },
    { question: t(FAQMessages.Q3), answer: t(FAQMessages.A3) },
    { question: t(FAQMessages.Q6), answer: t(FAQMessages.A6) },
    { question: t(FAQMessages.Q7), answer: t(FAQMessages.A7) },
  ];
}
